module.exports = __webpack_public_path__ + "photowithbook.jpg?4849ad26f92fe1343bfa9a76da426543";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photowithbook.jpg
// module id = 32
// module chunks = 0